module.exports = __webpack_public_path__ + "static/media/1_Odori Park - Sapporo.c200ba29.jpg";